module.exports = __webpack_public_path__ + "static/media/Wood_Grain.cf40f227.png";